import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { trialInfo } from "../../Constant/constant";
import {
  getSettingsListAll,
  UpdateSettingsPage,
} from "../../../redux/settings/action";
import Spinner from "../../Layouts/Spinner";
import "../../Common/Styles/AdminEnhancements.css";

const MemberShipData = () => {
  const [loading, setLoading] = useState(false);

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      max_invoices: settingsListData && settingsListData.max_invoices ? settingsListData.max_invoices : "",
      max_invoices1: settingsListData && settingsListData.max_invoices1 ? settingsListData.max_invoices1 : "",
      max_invoices2: settingsListData && settingsListData.max_invoices2 ? settingsListData.max_invoices2 : "",
      max_invoices3: settingsListData && settingsListData.max_invoices3 ? settingsListData.max_invoices3 : "",
      max_invoices4: settingsListData && settingsListData.max_invoices4 ? settingsListData.max_invoices4 : "",
      duration_type: settingsListData && settingsListData.duration_type ? settingsListData.duration_type : "",
      duration: settingsListData && settingsListData.duration ? settingsListData.duration : "",
    },
    validationSchema: trialInfo(),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading))
      .then((res) => {
        if (res.data.status) {
          formik.resetForm();
        }
      })
      .catch((e) => console.log("error", e));
  };

  const handleGenderChange = (e) => {
    const gender = e.target.value;
    formik.setFieldValue("duration_type", Number(gender));
  };

  return (
    <div className="p-3">
      <h3 className="pb-2">Add Trial Info</h3>
      <div className="admin-highlight-box mb-3">Trial settings use admin-facing labels for clarity. Monthly and Semi-Annual here describe the website setup view.</div>
      <div className=" category-wrapper">
        <p className="bredcrumbs">
          <a onClick={() => navigate("/")}>Home &gt;</a>Add Trial
        </p>
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-5">
              <div className="form-group col-md-12">
                <label htmlFor="duration_type">Duration Type</label>
                <select
                  id="duration_type"
                  name="duration_type"
                  className="form-control"
                  onChange={handleGenderChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration_type}
                >
                  <option value="">Select Duration type</option>
                  <option value="3">Day</option>
                  <option value="1">Monthly</option>
                  <option value="2">Semi-Annual</option>
                </select>
                {formik.touched.duration_type && formik.errors.duration_type ? (
                  <div className="error">{formik.errors.duration_type}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Duration</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter duration"
                  name="duration"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration}
                />
                {formik.touched.duration && formik.errors.duration ? (
                  <div className="error">{formik.errors.duration}</div>
                ) : null}
              </div>
            </div>

            <div className=" col-md-7 d-flex justify-content-center">
              <div className="table-responsive ">
                <table className="table">
                  <thead>
                    <th>Invoice Type</th>
                    <th>Limited Number</th>
                    <th>Unlimited Number</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Simplified</td>
                      <td>
                        {formik.values.max_invoices !== 10000 && (
                          <>
                            <input
                              min="0"
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices &&
                                formik.errors.max_invoices
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices}
                            />
                            {formik.touched.max_invoices &&
                              formik.errors.max_invoices && (
                                <div className="error">
                                  {formik.errors.max_invoices}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices === 10000}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>VAT</td>
                      <td>
                        {formik.values.max_invoices1 !== 10000 && (
                          <>
                            <input
                              min="0"
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices1 &&
                                formik.errors.max_invoices1
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices1"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices1}
                            />
                            {formik.touched.max_invoices1 &&
                              formik.errors.max_invoices1 && (
                                <div className="error">
                                  {formik.errors.max_invoices1}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices1",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices1 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Purchase</td>
                      <td>
                        {formik.values.max_invoices2 !== 10000 && (
                          <>
                            <input
                              min="0"
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices2"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices2}
                            />
                            {formik.touched.max_invoices2 &&
                              formik.errors.max_invoices2 && (
                                <div className="error">
                                  {formik.errors.max_invoices2}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices2",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices2 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Credit Notes</td>
                      <td>
                        {formik.values.max_invoices3 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter credit note..."
                              name="max_invoices3"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices3}
                            />
                            {formik.touched.max_invoices3 &&
                              formik.errors.max_invoices3 && (
                                <div className="error">
                                  {formik.errors.max_invoices3}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices3",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices3 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Debit Notes</td>
                      <td>
                        {formik.values.max_invoices4 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter debit note..."
                              name="max_invoices4"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices4}
                            />
                            {formik.touched.max_invoices4 &&
                              formik.errors.max_invoices4 && (
                                <div className="error">
                                  {formik.errors.max_invoices4}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices4",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices4 === 10000}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              type="button"
              className="submit-btn"
              onClick={() => {
                navigate(-1);
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberShipData;
